import { createQueryKeys } from '@lukemorales/query-key-factory'

export const assistant = createQueryKeys('assistant', {
  conversations: null,
  conversation: (conversationId: string) => ({
    queryKey: [conversationId],
    contextQueries: {
      messages: null,
      message: (messageId: string) => [messageId],
    },
  }),
  examplePrompts: null,
})
